import { render, staticRenderFns } from "./ConfiguracionCostos.vue?vue&type=template&id=87f5de5e&"
import script from "./ConfiguracionCostos.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionCostos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports